import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getOrganizationProjects,
  GetOrganizationProjectsParams
} from "Api/organizations/projects/getOrganizationProjects.request";
import { OrganizationProjectsList } from "Api/organizations/projects/OrganizationProjects.types";
import logger from "Libs/logger";
import { organizationByDescriptionIdSelector } from "Reducers/organization/organization";
import { loadingOrganizationProjectsSelector } from "../projects.selectors";
import type { AsyncThunkOptionType } from "Reducers/types";
interface ErrorResponse {
  title?: string;
  description?: string;
}

export const getProjects = createAsyncThunk<
  OrganizationProjectsList,
  { organizationId: string; params?: GetOrganizationProjectsParams },
  AsyncThunkOptionType
>(
  "app/organization/get_projects",
  async ({ organizationId, params }, { rejectWithValue, getState }) => {
    try {
      const organization = organizationByDescriptionIdSelector(getState(), {
        organizationDescriptionId: organizationId
      });

      if (!organization) {
        return rejectWithValue("Organization does not exit");
      }

      const projects = await getOrganizationProjects(organization.id, params);

      return projects;
    } catch (err: unknown) {
      const error = err as ErrorResponse;
      const errorMessage =
        error.title || error.description || "An error has occurred";

      logger(err, {
        action: "get_organization_project",
        organizationId
      });

      return rejectWithValue(errorMessage);
    }
  },
  {
    condition: (_, { getState }) => {
      return !loadingOrganizationProjectsSelector(getState());
    }
  }
);
